module.exports = __webpack_public_path__ + "img/hero-about.d87c21fd.svg";